/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import utils from '../../utils'

import firebase from '../../config/firebase'
import DashboardActions from '../../reducers/dashboardReducer'

class DownloadUploadButton extends React.PureComponent {
  fileReader = new FileReader()

  fileInputRef = React.createRef()

  downloadLinkRef = React.createRef()

  state = {
    downloading: false,
    uploading: false,
    downloadUrl: '',
  }

  onDownloadClick = () => {
    const { orders } = this.props

    this.uploadFile(`report/report-dashboard.json`, JSON.stringify(orders))
  }

  getDatesExcludeStartEnd = (startDate, endDate) => {
    const dateArray = []
    let afterStartDate = moment(startDate)
    const beforeEndDate = moment(endDate)

    while (afterStartDate < beforeEndDate) {
      dateArray.push(moment(afterStartDate).format('YYYY-MM-DD'))
      afterStartDate = moment(afterStartDate).add(1, 'days')
    }

    return dateArray
  }

  generateCsvReport = dates => {
    let csvString = ''
    const header = [
      'Date',
      'Total Orders',
      'Completed Orders',
      'Rejected Orders',
      'Total Express Orders',
      'Total Express Completed Orders',
      'Total Express Rejected Orders',
      'Total Paying Customers',
      'Order Value (AVG)',
      'Order Commission Rate (AVG)',
      'Delivery Value (AVG)',
      'Delivery Commission Rate (AVG)',
      'Delivery Commission Earned (AVG)',
      'Merchant Commission Rate (AVG)',
      'Merchant Commission Earned (AVG)',
      'Total Earn Commission',
      'Total New Paying Customers',
      'Total New Non-paying Customers',
      'Total Discount Amount (Instant Discount)',
      'Promo code Discount Amount',
      'Frequency of order',
    ].join(', ')
    csvString = csvString.concat(`${header} \n`)

    const { orders, customers, expressOrders } = this.props
    _.forEach(dates, date => {
      let completedOrderCount = 0
      let rejectedOrderCount = 0
      let orderCount = 0
      let promoCodeDiscount = 0
      let orderDiscount = 0
      let newPayingCustomerCount = 0
      let newNonPayingCustomerCount = 0
      let expressOrderCount = 0
      let completedExpressOrderCount = 0
      let rejectedExpressOrderCount = 0
      const allCustomers = []
      const allOrderValue = []
      const allDeliveryValue = []
      const allMerchantCommission = []
      const allDeliveryCommission = []
      const allCommissionEarn = []
      const allMerchantCommissionRate = []
      const allDeliveryCommissionRate = []
      const customerOrders = {}

      _.forEach(orders, (order, orderKey) => {
        const { status } = order
        const orderDate = moment(order.created_at).format('YYYY-MM-DD')
        if (orderDate === date) {
          orderCount += 1
          if (status === 'delivered') {
            const orderValue = Number(order.sub_total)
            const merchantCommission = utils.order.getOrderCommissionFee(order)
            const deliveryCommission = utils.order.getOrderDeliveryCommissionFee(order)
            const earnCommission = Number(parseFloat(merchantCommission + deliveryCommission).toFixed(2))
            const merchantCommissionRate = Number(order.discount_rate)
            const deliveryValue = Number(order.delivery_fee)
            const deliveryCommissionRate = Number(order.deliverer_fee_rate || 10)

            customerOrders[order.deliveree] = {
              ...customerOrders[order.deliveree],
              [orderKey]: order,
            }
            completedOrderCount += 1
            promoCodeDiscount += order.voucher ? order.voucher.order.discount_amount / 100 : 0
            orderDiscount += order.promotion_discount

            allOrderValue.push(orderValue)
            allDeliveryValue.push(deliveryValue)
            allMerchantCommission.push(merchantCommission)
            allDeliveryCommission.push(deliveryCommission)
            allCommissionEarn.push(earnCommission)
            allMerchantCommissionRate.push(merchantCommissionRate)
            allDeliveryCommissionRate.push(deliveryCommissionRate)
            allCustomers.push(order.deliveree)
          }
          if (status === 'rejected') {
            rejectedOrderCount += 1
          }
        }
      })

      _.forEach(customers, customer => {
        const createdDate = moment(customer.created_at).format('YYYY-MM-DD')
        if (createdDate === date) {
          if ((customer.delivered_order_count || 0) > 0) {
            newPayingCustomerCount += 1
          } else {
            newNonPayingCustomerCount += 1
          }
        }
      })

      _.forEach(expressOrders, express => {
        const { status } = express
        const createdDate = moment(express.created_at).format('YYYY-MM-DD')
        if (createdDate === date) {
          expressOrderCount += 1
          if (status === 'delivered') {
            completedExpressOrderCount += 1
          } else if (status === 'drafted') {
            rejectedExpressOrderCount += 1
          }
        }
      })

      const deliveryValueAvg = Number(parseFloat(_.mean(allDeliveryValue)).toFixed(2)) || 0
      const deliveryCommissionAvg = Number(parseFloat(_.mean(allDeliveryCommission)).toFixed(2)) || 0
      const deliveryCommissionRateAvg = Number(parseFloat(_.mean(allDeliveryCommissionRate)).toFixed(2)) || 0

      const orderValueTotal = Number(parseFloat(_.mean(allOrderValue)).toFixed(2)) || 0
      const orderCommissionAvg = Number(parseFloat(_.mean(allMerchantCommission)).toFixed(2)) || 0
      const merchantCommissionRateAvg = Number(parseFloat(_.mean(allMerchantCommissionRate)).toFixed(2)) || 0
      const merchantCommissionEarnAvg = Number(parseFloat(_.mean(allCommissionEarn)).toFixed(2)) || 0
      const earnCommissionTotal = Number(parseFloat(_.sum(allCommissionEarn)).toFixed(2)) || 0
      const payingCustomerTotal = _.size(_.uniq(allCustomers))
      const orderAvg = Number(parseFloat(_.mean(_.map(customerOrders, orders => _.size(orders))).toFixed(2)))

      const rowString = [
        date,
        orderCount,
        completedOrderCount,
        rejectedOrderCount,
        expressOrderCount,
        completedExpressOrderCount,
        rejectedExpressOrderCount,
        payingCustomerTotal,
        orderValueTotal,
        orderCommissionAvg,
        deliveryValueAvg,
        deliveryCommissionRateAvg,
        deliveryCommissionAvg,
        merchantCommissionRateAvg,
        merchantCommissionEarnAvg,
        earnCommissionTotal,
        newPayingCustomerCount,
        newNonPayingCustomerCount,
        parseFloat(orderDiscount).toFixed(2),
        parseFloat(promoCodeDiscount).toFixed(2),
        orderAvg,
      ].join(', ')
      csvString = csvString.concat(`${rowString} \n`)
    })

    return csvString
  }

  onDownloadCsvClick = () => {
    const { startDate, endDate } = this.props
    const dates = this.getDatesExcludeStartEnd(startDate, endDate)
    const data = this.generateCsvReport(dates)

    this.uploadFile(`report/metric-report.csv`, data)
  }

  onClearFile = () => {
    this.fileReader.abort()
    this.fileInputRef.value = ''
  }

  onReadFile = () => {
    const self = this

    this.fileReader.onload = event => {
      const ordersFromJson = JSON.parse(event.target.result)
      self.props.getOrderByDateSuccess(ordersFromJson)
      self.onClearFile()
    }

    this.fileReader.onloadstart = () => {
      self.setState({ uploading: true })
    }
    this.fileReader.onloadend = () => {
      self.setState({ uploading: false })
    }
  }

  onFileChange = e => {
    const file = e.target.files[0]

    if (file) {
      this.onReadFile()
      this.fileReader.readAsText(file)
    }
  }

  uploadFile(filename, jsonText) {
    const self = this

    const storage = firebase
      .storage()
      .ref()
      .child(filename)

    this.setState({ downloading: true })
    storage.putString(jsonText.toString()).then(snapshot => {
      self.downloadFile(snapshot)
    })
  }

  downloadFile(snapshot) {
    const self = this

    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  render() {
    const { downloading, uploading, downloadUrl } = this.state
    const { orders, customers, loading } = this.props

    return (
      <div style={{ position: 'absolute', right: 14, top: 14 }}>
        <Button
          disabled={downloading || loading || (_.size(orders) === 0 && _.size(customers) === 0)}
          loading={downloading}
          onClick={this.onDownloadCsvClick}
        >
          Download CSV
        </Button>
        <Button
          disabled={downloading || loading || _.size(orders) === 0}
          loading={downloading}
          onClick={this.onDownloadClick}
        >
          Download Report
        </Button>
        <Button disabled={loading || uploading} loading={uploading} onClick={() => this.fileInputRef.click()}>
          Upload Report
        </Button>
        <a
          href={downloadUrl}
          ref={ref => {
            this.downloadLinkRef = ref
          }}
          style={{ display: 'none' }}
        />
        <input
          type="file"
          accept=".json"
          hidden
          ref={ref => {
            this.fileInputRef = ref
          }}
          onChange={this.onFileChange}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ dashboard }) => ({
  orders: dashboard.dashboardOrders,
  expressOrders: dashboard.expressOrders,
  loading: dashboard.loading,
  customers: dashboard.dashboardCustomers,
  startDate: dashboard.orderStartAt,
  endDate: dashboard.orderEndAt,
})

const mapDispatchToProps = dispatch => ({
  getOrderByDateSuccess: orders => dispatch(DashboardActions.getOrderByDateSuccess(orders)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadUploadButton)



// WEBPACK FOOTER //
// ./src/components/Dashboard/DownloadUpload.js